import type { NavigateFunction } from 'react-router-dom';

/**
 * Allows programmatic navigation outside React components (interceptors, utils, etc)
 */
class NavigationProvider {
  private navigateFunction: NavigateFunction | null = null;

  /**
   * Set the navigate function from a React component
   */
  setNavigate(navigate: NavigateFunction): void {
    this.navigateFunction = navigate;
  }

  /**
   * Navigate to a specific route
   */
  navigate(path: string, options?: { replace?: boolean; state?: any }): void {
    if (!this.navigateFunction) {
      // eslint-disable-next-line no-console
      console.warn('Navigate function not set. Falling back to window.location');
      return;
    }

    this.navigateFunction(path, options);
  }

  /**
   * Check if navigator is available
   */
  isAvailable(): boolean {
    return this.navigateFunction !== null;
  }
}

export const navigationProvider = new NavigationProvider();
